import { render, staticRenderFns } from "./AppHeader_Navs.vue?vue&type=template&id=83ef058a&scoped=true&"
import script from "./AppHeader_Navs.vue?vue&type=script&lang=js&"
export * from "./AppHeader_Navs.vue?vue&type=script&lang=js&"
import style0 from "./AppHeader_Navs.vue?vue&type=style&index=0&id=83ef058a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ef058a",
  null
  
)

export default component.exports